

$(document).on(
  "click",
  "#main-nav .nav-row ul .contains-children>a",
  function () {
    var attr = $(this).attr("href");
    var site_url = "https://thepaperandplanco.com";
    var main_url = site_url + "" + attr;
    window.location.href = main_url;
  }
);
$(document).on(
  "click",
  "#main-nav .nav-row ul .contains-children   span.exp",
  function (e) {
    e.preventDefault();
    $(this).closest("li").toggleClass("mobile-expanded");
  }
);
$(document).on("change", ".checkout_checkbox input", function (e) {
  if ($(this).is(":checked")) {
    //checked
    $("#update-cart").removeClass("btn_disabled");
  } else {
    //unchecked
    $("#update-cart").addClass("btn_disabled");
  }
});


// Plan Your Day Slider Js


(function($){	
setTimeout(function() {
        jQuery('#plan-slider').owlCarousel({
            margin: 30,
            loop:true,
		 	slideSpeed : 300,
			paginationSpeed : 400,
			nav:true,
			pagination:true,  
			dots: false,
			navText: ["<img src='https://cdn.shopify.com/s/files/1/0450/3502/8634/files/Group_513020.png?v=1698645999'>","<img src='https://cdn.shopify.com/s/files/1/0450/3502/8634/files/Group_513021.png?v=1698645915'>"],
            responsive: {
                0:{
	            items:1
				},
				480:{
					items:1
				},
				768:{
					items:1
				},
				1000:{
					items:1
				},
				1100:{
					items:1
				}
            }

        });
    }, 3000);
	}) (jQuery);	





